import httpRequest from './http-request';
import { isDev, isTest, mapAcademyResources } from '@/utils';

class Search {
  constructor() {
    this.domain = isDev() ? '/searchapi' : (isTest() ? `//data-search-test.wps.com` : `//data-search.wps.com`);
  }

  /**
    * 搜索接口
    */
  async getAcademyResources({
    pageNum,
    pageSize,
    keyword,
    sortBy = 'cool',
    order = 'desc',
    post_type,
    top_cate
  } = {}) {
    let deviceId = '';
    let academy_params = {
      sort_by: sortBy,
      order,
      client_type: ['pc'],
      post_type,
      top_cate
    };
    let _params = {};
    Object.keys(academy_params).forEach(key => {
      if (academy_params[key]) {
        _params[key] = academy_params[key];
      }
    });
    const res = await httpRequest.query({
      url: `${this.domain}/search/resource/academy`,
      options: {
        method: 'post',
        data: {
          device_id: deviceId,
          pageNum,
          pageSize,
          keyword,
          platform: 1,
          position: 'web_wps_academy_search_input_bar',
          resource_params: {
            academy_params: _params,
          },
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
    });

    if (res && res.code === 0) {
      const resource = res.data.academy_resource;
      return {
        total: resource.total,
        data: mapAcademyResources(resource.resources),
      };
    }

    return null;
  }

  /**
   * 搜索关联词
   */
  async getSearchAssociate({
    keyword,
  } = {}) {
    let url = `${this.domain}/search/academy/suggest?keyword=${keyword}`
    const res = await httpRequest.query({
      url
    });

    if (res && res.code === 0) {
      const resource = res.data;
      return resource;
    }

    return null;
  }

};

export default new Search();


// WEBPACK FOOTER //
// ./src/services/search.js